var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTpWorkIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M24.5193 9.44219C24.9974 8.76468 26.0022 8.76468 26.4803 9.44219L45.4736 36.3582C46.0345 37.1532 45.466 38.2501 44.4931 38.2501H6.50648C5.53358 38.2501 4.96508 37.1531 5.52601 36.3582L24.5193 9.44219Z",
    fill: "#F9536E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 46.75H47.75",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 4.25H15.875C9.5 4.25 7.375 8.05375 7.375 12.75V46.75H45.625V12.75C45.625 8.05375 43.5 4.25 37.125 4.25Z",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8772 31.875H22.101C21.0172 31.875 20.1035 32.7675 20.1035 33.8725V46.75H32.8535V33.8725C32.8748 32.7675 31.9822 31.875 30.8772 31.875Z",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12.75V23.375",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 18.0625H31.8125",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpWorkIcon06);
export default __webpack_public_path__ + "static/media/tp-work-icon06.70cf382a7766ae8510d53ed6eb44cd52.svg";
export { ForwardRef as ReactComponent };